import { Text } from "@fluentui/react-northstar";
import React from "react";
import { useTranslation } from "react-i18next";
import taskSolidIcon from "../../../images/print/lifecycle/tasks-solid.png";
import collaboratorsIcon from "../../../images/print/ticket-details/collaborators.png";
import groupIcon from "../../../images/print/ticket-details/group.png";
import teamIcon from "../../../images/print/ticket-details/team.png";
import userIcon from "../../../images/print/ticket-details/user.png";
import { appState } from "../../AppState";
import { TicketTaskStatus } from "../../shared/components/TicketCardTemplate";
import { LIFECYCLE } from "../../shared/utils/constants";

type TaskPrintProps = {
  tasks: TicketTask[];
  powerAutomate?: boolean;
};

export const TaskPrint: React.FC<TaskPrintProps> = ({
  tasks,
  powerAutomate,
}) => {
  const currentState = appState();
  const { t } = useTranslation();
  if (tasks.length === 0) return null;
  return (
    <div className="mb-2">
      <Text weight="semibold" className="mb-3 print-text-color">
        {powerAutomate ? LIFECYCLE.POWER_AUTOMATE_TASKS : LIFECYCLE.TASKS}
      </Text>
      <div className="flex items-start flex-wrap mb-3">
        {tasks.map((task, index) => (
          <div
            className={`w-1/2 ${index % 2 === 0 ? "pr-4" : "pl-4"} mt-4`}
            key={task.Id}
          >
            <div className="flex items-center mb-1 justify-between pb-1 border-b">
              <div className="flex items-center mr-2">
                <img src={taskSolidIcon} alt="task icon" width="16px" />
                <Text
                  size="large"
                  weight="semibold"
                  className="ml-1 print-text-color"
                >
                  {task.Title}
                </Text>
              </div>
              <TicketTaskStatus status={task.Status} postion="end" />
            </div>
            {task?.Assignee && (
              <div className="flex items-center gap-2 print-text-color">
                <img
                  src={userIcon}
                  alt="user icon"
                  width="12px"
                  className="mr-2"
                />
                <Text
                  size="medium"
                  weight="semibold"
                  className="ml-1 print-text-color"
                >
                  {t("ticket.ticket-list.assignee")}:
                </Text>
                <Text
                  size="medium"
                  weight="regular"
                  className="ml-1 print-text-color"
                >
                  {task.Assignee.FullName}
                </Text>
              </div>
            )}
            {task?.Team && (
              <div className="flex items-center gap-2 print-text-color">
                <img
                  src={teamIcon}
                  alt="team icon"
                  width="12px"
                  className="mr-2"
                />
                <Text
                  size="medium"
                  weight="semibold"
                  className="ml-1 print-text-color"
                >
                  {t("ticket.ticket-list.team")}:
                </Text>
                <Text
                  size="medium"
                  weight="regular"
                  className="ml-1 print-text-color"
                >
                  {task.Team.Name}
                </Text>
              </div>
            )}
            {task?.SupportGroup && (
              <div className="flex items-center gap-2 print-text-color">
                <img
                  src={groupIcon}
                  alt="group icon"
                  width="12px"
                  className="mr-2"
                />
                <Text
                  size="medium"
                  weight="semibold"
                  className="ml-1 print-text-color"
                >
                  {t("ticket.ticket-list.group")}:
                </Text>
                <Text
                  size="medium"
                  weight="regular"
                  className="ml-1 print-text-color"
                >
                  {task.SupportGroup.Name}
                </Text>
              </div>
            )}
            {task?.TaskCollaborators.length > 0 && (
              <div className="flex items-start gap-2 print-text-color">
                <div className="flex items-center gap-2 print-text-color">
                  <img
                    src={collaboratorsIcon}
                    alt="group icon"
                    width="12px"
                    className="mr-2"
                  />
                  <Text
                    size="medium"
                    weight="semibold"
                    className="ml-1 print-text-color"
                  >
                    {t("ticket.ticket-list.collaborators")}:
                  </Text>
                </div>
                <div className="flex items-start print-text-color flex-wrap ml-1">
                  {task.TaskCollaborators.map((collaborator, index) => {
                    const user = currentState.usersInRole.find((pu) => pu.Id === collaborator.PlatformUserId);
                    return (!user) ? null : (<Text size="medium" className="ml-1" key={user.AadObjectId}>{user.FullName}{index !== task.TaskCollaborators.length - 1 && ", "}</Text>);
                  })}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
